import { ITruckerProfileProps } from 'interfaces/profile.interface';

const mockTruckerData: ITruckerProfileProps = {
  trucker: {
    id: 'PWE',
    uuid: '960c39b7-da19-4aa2-a548-7b86724537c7',
    name: 'LUIZ EDUARDO COSTA',
    cpf: '02612345678',
    selfieUri: 'selfie',
    isVip: false,
    planType: 'vip',
    inContactList: true,
    phones: [
      {
        ddd: 64,
        number: 993001277,
        hasWhatsapp: true,
      },
    ],
    address: {
      city: 'Morrinhos',
      state: 'GO',
      district: 'bairro',
      street: 'ruaZ',
      number: '',
      complement: '',
      zipCode: '75650000',
    },
    cnh: {
      name: 'LUIZ EDUARDO COSTA DA MOTA LEITE',
      category: 'AB',
      expirationDate: 'Out/2028',
      timeSinceFirstLicense: '7 anos',
    },
    timeSinceCreated: '4 anos',
    registrationDate: '21/04/2018',
    mainDestination: {
      city: 'Rondon do Pará',
      state: 'PA',
    },
    mainProducts: [
      'AÇO',
      'CARVÃO',
      'PEDRA',
      'GRÃOS',
      'CIMENTO',
      'ELETRÔNICOS',
      'FARELO DE SOJA',
      'PREPARAÇÕES DE PRODUTO HORTÍCULAS',
    ],
    lastLocation: {
      city: 'São Paulo',
      state: 'SP',
      timeSinceCollected: '16 minutos',
      distance: 10,
      hasDistance: true,
      coordinates: {
        latitude: -19.8905991,
        longitude: -44.4353226,
      },
      isApproximated: true,
    },
    bank: {
      name: 'DOCK IP SA',
      number: '301',
      account: {
        type: '',
        document: '02069770184',
        number: '3044562',
        branchNumber: '0001',
        createdAt: '0001-01-01T00:00:00Z',
      },
      pix: [{ key: '1323849', status: 'active', type: 'phoneNumber' }],
    },
    vehicles: [
      {
        id: 'ojk',
        tractor: {
          type: 'Bitruck',
          plate: 'BWI-4442',
        },
        rntrc: '****86100',
        rntrcEmissionDate: '23/04/2024',
        body: [
          {
            name: 'Baú',
            plate: 'body-1111',
          },
          {
            name: 'Baú',
            plate: 'body-1222',
          },
          {
            name: 'Baú',
            plate: 'body-1333',
          },
          {
            name: 'Baú',
            plate: 'body-1444',
          },
        ],
        tracker: 'Tem, mas não sei a marca',
        locator: 'Não tem localizador',
        images: ['img1', 'img2'],
      },
      {
        id: 'j9rx',
        tractor: {
          type: 'Truck',
          plate: 'NVR-2742',
        },
        rntrc: '****32133',
        rntrcEmissionDate: '23/05/2024',
        body: [],
        tracker: 'Sim',
        locator: 'Não tem localizador',
        images: [],
      },
    ],
    availability: {
      isAvailable: true,
      originLocation: 'São Paulo',
      originUF: 'SP',
      locationType: 'city',
      destination: 'Bauru - SP',
      currentCapacity: '750.00kg',
      totalCapacity: '1440.00kg',
      timeSinceCollected: '5 horas',
    },
  },
  evaluation: {
    grade: 3.3,
    total: 19,
    attributes: [
      'Pontualidade',
      'Boa comunicação',
      'Documentação em dia',
      'Atraso na entrega',
      'Mau comportamento',
      'Problemas de comunicação',
      'Atraso na coleta',
      'Não apareceu para carregar',
      'Cuidado com a carga',
      'Carga furtada',
      'Carga danificada',
      'Caminhão com problemas',
    ],
  },
  journey: {
    total: 156,
    totalCompanies: 18,
    maxValueTrips: '300000.00',
    averageValueTrips: '65000.00',
  },
  isVerified: false,
  isBlocked: false,
  wasSearchedByCpf: true,
  securityAnalysis: {
    documents: [
      {
        description: 'SELFIE',
        status: 'APROVADO',
      },
      {
        description: 'CNH',
        status: 'APROVADO',
      },
      {
        description: 'CPF',
        status: 'NÃO APROVADO',
      },
      {
        description: 'ENDEREÇO',
        status: 'APROVADO',
      },
    ],
  },
  lastSearches: {
    totalApprovedSearches: 1,
    lastApprovedDate: '2024-05-01 17:42:27',
    lastFiveApprovedProducts: [''],
    maxApprovedCargoPrice: '',
    lastSearchData: [],
  },
  freight: {
    deposit: {
      proposalStatus: '',
      proposalId: '65fb4e23478b73133a3ca436',
      grStatus: 'PROFILE_APPROVED',
    },
  },
  stamps: {
    newlyRegistered: false,
    position: [
      {
        key: 'motorista_recorrente',
        icon: 'trip',
        iconStyled: 'outlined',
        title: 'Motorista recorrente',
        subtitle: 'Muitas viagens.',
        value: true,
      },
      {
        key: 'facil_negociacao',
        icon: 'handshake',
        iconStyled: 'outlined',
        title: 'Fácil negociação',
        subtitle: 'Responde rápido.',
        value: true,
      },
      {
        key: 'bom_motorista',
        icon: 'reward',
        iconStyled: 'outlined',
        title: 'Bom motorista',
        subtitle: 'Vários elogios.',
        value: true,
      },
    ],
  },
};

export { mockTruckerData };
